export const IconSystemAlert = (props) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_6003_108)">
        <path
          d="M10.7218 2.5L18.6602 16.25C18.7333 16.3767 18.7718 16.5204 18.7718 16.6667C18.7718 16.8129 18.7333 16.9566 18.6602 17.0833C18.587 17.21 18.4818 17.3152 18.3552 17.3884C18.2285 17.4615 18.0848 17.5 17.9385 17.5H2.06183C1.91555 17.5 1.77185 17.4615 1.64517 17.3884C1.51849 17.3152 1.41329 17.21 1.34016 17.0833C1.26702 16.9566 1.22851 16.8129 1.22852 16.6667C1.22852 16.5204 1.26702 16.3767 1.34016 16.25L9.27849 2.5C9.35164 2.37333 9.45683 2.26814 9.58351 2.19501C9.71019 2.12188 9.85389 2.08337 10.0002 2.08337C10.1464 2.08337 10.2901 2.12188 10.4168 2.19501C10.5435 2.26814 10.6487 2.37333 10.7218 2.5ZM3.50516 15.8333H16.4952L10.0002 4.58334L3.50516 15.8333ZM9.16683 13.3333H10.8335V15H9.16683V13.3333ZM9.16683 7.5H10.8335V11.6667H9.16683V7.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6003_108">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
